import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Routes from './Routes';

const Router = () => (
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);

export default Router;
